import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { useBaseLocalePicker } from 'articleEditor/components/localePicker/useBaseLocalePicker';
import { useEditorLanguages } from 'articleEditor/components/localePicker/useLocales';
import { useTranslateArticle } from 'articleEditor/hooks/translations/useTranslateArticle';
import { useAtomValue } from 'jotai';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';
import { ampli } from 'lib-shared-tracking';

import s from './localePicker.module.scss';

export const LocalePickerWithTranslation = (): JSX.Element => {
  const { featureFlags } = useAtomValue(featureFlagsAtom);
  const { defaultLanguage } = useEditorLanguages();
  const translateArticle = useTranslateArticle();
  return useBaseLocalePicker({
    tabRenderer: (language, renderDeleteButton, onDeleteTranslation) => {
      if (!featureFlags.aiAutoTranslation) {
        return renderDeleteButton(language);
      }
      return (
        <DropdownButton
          noArrow
          fixed
          icon="dots-v"
          buttonProps={{ variant: 'tertiary' }}
          dropdown={
            <ButtonList>
              {language.languageId !== defaultLanguage.languageId && (
                <ButtonList.Item
                  icon="translate"
                  onClick={() => {
                    ampli.knowledgeTranslateArticleClicked({
                      languageId: language.languageId,
                    });
                    translateArticle();
                  }}
                >
                  Auto-translate
                </ButtonList.Item>
              )}
              <ButtonList.Item
                icon="trash"
                className={s.deleteButton}
                buttonClassName={s.deleteButton}
                onClick={() => {
                  onDeleteTranslation(language);
                }}
              >
                Delete
              </ButtonList.Item>
            </ButtonList>
          }
        />
      );
    },
  });
};
